import "./whatsapp_btn.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import Links from "../../../../constants/links";

function WhatsappBtn({ text = "Entre em contato", link, number, className = "" }) {
    let targetLink = link;

    if (number) {
        const cleanNumber = number.toString().replace(/\D/g, "");
        targetLink = `https://wa.me/55${cleanNumber}`;
    }

    if (!targetLink) {
        targetLink = Links.whatsapp;
    }

    return (
        <a
            href={targetLink}
            target="_blank"
            rel="noopener noreferrer"
            className={`whatsapp-btn ${className}`}
        >
            {text}
            <FontAwesomeIcon icon={faWhatsapp} className="whatsapp-icon" size="lg" />
        </a>
    );
}

export default WhatsappBtn;
